/**
 * Discriminated error codes for date + required-reason form validation.
 * Components map these to translated strings via useMessages.
 *
 * Shared across features — audit reopen and task change-due-date modals
 * validate the same pair of fields.
 */
export const DateReasonValidationError = {
  MISSING_DATE: 'MISSING_DATE',
  MISSING_REASON: 'MISSING_REASON',
  VALID: '',
} as const;

export type DateReasonValidationError =
  (typeof DateReasonValidationError)[keyof typeof DateReasonValidationError];

/**
 * Validates a date string and a required reason.
 * Returns a discriminated error code or empty string if valid.
 */
export function validateDateWithReason(
  date: string,
  reason: string,
): DateReasonValidationError {
  if (!date) return DateReasonValidationError.MISSING_DATE;
  if (!reason.trim()) return DateReasonValidationError.MISSING_REASON;
  return DateReasonValidationError.VALID;
}
